import { UpdateServiceReviewUseCase, UpdateServiceReviewParams } from "./index"
import { ServiceReviewsRepository } from "../../../repositories/serviceReviewsRepository"

export class UpdateServiceReviewUseCaseImpl implements UpdateServiceReviewUseCase {
	private _serviceReviewsRepository: ServiceReviewsRepository

	constructor({ ServiceReviewsRepository }: { ServiceReviewsRepository: ServiceReviewsRepository }) {
		this._serviceReviewsRepository = ServiceReviewsRepository
	}

	async exec(params: UpdateServiceReviewParams): Promise<void> {
		return await this._serviceReviewsRepository.updateServiceReview(params.reviewUpdate)
	}
}
